import script from "./AnexoUploadField.vue?vue&type=script&setup=true&lang=js"
export * from "./AnexoUploadField.vue?vue&type=script&setup=true&lang=js"

import "./AnexoUploadField.vue?vue&type=style&index=0&id=0198e509&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0198e509"]])

export default __exports__